import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {Router} from '@angular/router';
import {OptionService} from '../../../Services/option.service';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {ModelService} from '../../../Services/model.service';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import * as _ from 'lodash';

@Component({
  selector: 'app-archive-option-view',
  templateUrl: './archive-option-view.component.html',
  styleUrls: ['./archive-option-view.component.scss']
})
export class ArchiveOptionViewComponent implements OnInit {
  @ViewChild('optionsRowDetail', {static: false}) optionsRowDetail: any;
  public grid: Grid;
  public optionId: number;
  public optionName: string;
  public dataArray;
  public unionName;

  @ViewChild('readdModel', {static: false}) readdModel = null;
  @ViewChild('activeModels', {static: false}) activeModels = null;
  @ViewChild('modelTooltip', {static: false}) modelTooltip = null;

  constructor(
    private router: Router,
    private optionService: OptionService,
    private translateService: TranslateService,
    private broadCastService: BroadcastService,
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.option.name',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          minWidth: 200,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.option.system_description',
          prop: 'systemDescription',
          sortable: true,
          type: TextColumn.type,
          minWidth: 240,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.option.active_modals',
          prop: 'optionProducts',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          noTruncate: true,
          valueTemplate: this.modelTooltip,
          valueFormatter: row => {
            const models = _.unionBy(row, 'model.id');
            return models.length;
          },
        },
        <TextColumn>{
          name: 'doctrine.option.status',
          prop: 'status',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('global.active');
              case false:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-plus fa-lg',
              tooltip: 'global.readd',
              onclick: row => {
                this.optionId = row.id;
                this.optionName = row.name.bold();
                this.readdModel.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        },
      ],
      service: this.optionService,
      rememberURL: this.router.url,
      method: 'getOption',
      defaultSort: 'position',
      rowDetailTemplate: this.optionsRowDetail,
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      archive: true,
    };

  }

  readd() {
    this.optionService.readdOption(this.optionId).subscribe((res) => {
      this.broadCastService.broadcast('refreshGrid', 'getOption');
      this.readdModel.hide();
    });
  }

  calcModel(row) {
    const union = _.unionBy(row.optionProducts, (item) => item['model'].id);
    this.dataArray = union;
    return true;
  }
}
